/**
 * @generated SignedSource<<cf207d38cce0a3dbc02d1cc7dbf56752>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "playlist" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchAssetsObjectSchema_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultAssetsObjectSchema";
  readonly description: string;
  readonly id: string;
  readonly lastModifiedDate: string | null;
  readonly objectSchemaEntity: {
    readonly displayName: string | null;
    readonly links: {
      readonly web: string | null;
    } | null;
    readonly name: string | null;
  } | null;
  readonly title: string;
  readonly type: SearchResultType;
  readonly " $fragmentType": "searchAssetsObjectSchema_AtlassianSearchPage";
};
export type searchAssetsObjectSchema_AtlassianSearchPage$key = {
  readonly " $data"?: searchAssetsObjectSchema_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchAssetsObjectSchema_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchAssetsObjectSchema_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "concreteType": "AssetsSchema",
      "kind": "LinkedField",
      "name": "objectSchemaEntity",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "displayName"
        },
        {
          "concreteType": "AssetsLinks",
          "kind": "LinkedField",
          "name": "links",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "web"
            }
          ]
        }
      ]
    }
  ],
  "type": "SearchResultAssetsObjectSchema"
};

(node as any).hash = "15d92df373ab87c956a322b3b67885b6";

export default node;
